var React = require('react');

function DownArrow (props) {
    return React.createElement("svg",props,React.createElement("g",null,React.createElement("path",{"d":"M22.88,20.53C22.71,20.2,22.37,20,22,20h-2.84V2c0-0.55-0.45-1-1-1h-4c-0.56,0-1,0.45-1,1v18H10   c-0.37,0-0.71,0.2-0.88,0.53c-0.18,0.32-0.16,0.72,0.05,1.02l6,9C15.35,30.83,15.67,31,16,31s0.65-0.17,0.83-0.45l6-9   C23.04,21.25,23.06,20.85,22.88,20.53z"})));
}

DownArrow.defaultProps = {"version":"1.1","x":"0px","y":"0px","viewBox":"0 0 32 32","enableBackground":"new 0 0 32 32","xmlSpace":"preserve"};

module.exports = DownArrow;

DownArrow.default = DownArrow;
